<template>
    <div>
        <form @submit.prevent="submitCredentialForm" data-vv-scope="Credential-Form" class="Credential-Form">
            <md-card>
                <md-card-content>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-size-50">
                            <md-field :class="{'md-invalid': errors.has('Credential-Form.apiUrl')}">
                                <label>API URL</label>
                                <md-input name="apiUrl" v-model="credentialService.credential.apiUrl" v-validate="'required'" />
                            </md-field>
                        </div>
                        <div class="md-layout-item md-size-50">
                            <md-field :class="{'md-invalid': errors.has('Credential-Form.secretKeyHex')}">
                                <label>Secret Key (HEX)</label>
                                <md-input name="secretKeyHex" v-model="credentialService.credential.secretKeyHex" v-validate="'required|min:32|max:32'" />
                            </md-field>
                        </div>
                    </div>
                </md-card-content>
                <md-progress-bar md-mode="indeterminate" v-if="loading" />
                <md-card-actions>
                    <md-button class="md-raised md-primary" type="submit">Save</md-button>
                </md-card-actions>
            </md-card>
        </form>
    </div>
</template>

<script>
import { CredentialService } from '../../services/CredentialService'
import { EventBus } from '@/shared/eventbus'

export default {
    name: 'Credential',
    data () {
        return { credentialService: new CredentialService(), loading: false }
    },
    mounted () {
        this.getCredential()
    },
    methods: {
        async getCredential () {
            await this.credentialService.getCredential()
        },
        async submitCredentialForm () {
            const validator = await this.$validator.validateAll('Credential-Form')
            if (!validator) return
            try {
                this.loading = true
                await this.credentialService.updateCredential()
                this.$notify({ group: 'notify', type: 'success', title: 'success', text: 'Credentials saved' })
                EventBus.$emit('Buyi Meter')
            } catch (e) {
                this.$notify({ group: 'notify', type: 'error', title: 'error', text: e.message })
            }
            this.loading = false
        },
    },
}
</script>
